import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsError = () => {
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.filters.noMatchingResults.tryThese"
      }), /*#__PURE__*/_jsxs(List, {
        marginBlockStart: "100",
        paddingInlineStart: "600",
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "repOverviewTable.filters.noMatchingResults.suggestion1"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "repOverviewTable.filters.noMatchingResults.suggestion2"
          })
        })]
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      paddingInlineStart: "0",
      name: "empty-state-charts"
    }),
    secondaryContentWidth: 250,
    titleText: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repOverviewTable.filters.noMatchingResults.noResultsFound"
      })
    })
  });
};
export default NoResultsError;